// extracted by mini-css-extract-plugin
export default {"wrapper":"EditTranche_wrapper__GdWqO","form":"EditTranche_form__gGlzl"};